export const toIndianRupeeFormat = (amount) => {
  if (!amount) return '0';
  
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const abbreviateNumber = (number) => {
  if (number >= 1e9) {
    return (number / 1e9).toFixed(1) + 'B';
  }
  if (number >= 1e6) {
    return (number / 1e6).toFixed(1) + 'M';
  }
  if (number >= 1e3) {
    return (number / 1e3).toFixed(1) + 'K';
  }
  return number.toString();
};

export const removeNumbersAndAfter = (tradingSymbol) => {
  const index = tradingSymbol.search(/\d/);
  return index !== -1 ? tradingSymbol.substring(0, index) : tradingSymbol;
};

export const extractDateFromSymbol = (tradingSymbol) => {
  const match = tradingSymbol.match(/\d{1,2}[A-Z]{3}\d{2}/);
  return match ? match[0] : null;
};